var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":_vm.bankDetails ? _vm.bankDetails.label : 'Interior Grouping',"headStyle":_vm.headStyle}},[_c('template',{slot:"extra"},[_c('a-button',{staticClass:"mr-1",attrs:{"disabled":_vm.loader,"type":"primary"},on:{"click":_vm.back}},[_vm._v("Exit")])],1),_c('a-spin',{attrs:{"tip":_vm.loaderTitle,"spinning":_vm.loader}},[(!_vm.bankDetails && _vm.loader)?_c('div',{staticStyle:{"height":"440px"}}):_vm._e(),(_vm.bankDetails)?_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12"},[_c('dynamic-table',{attrs:{"propData":{
            columns: _vm.columnDefs,
            rows: _vm.groupingList,
            create: _vm.create,
            screen: 'Grouping Bank',
            dropdownData: _vm.dropdownData,
            showAreaParams: false,
            constructionInfo: true,
            firstRowValues: _vm.bankDetails,
            constructionInfoData: {
              screenName: 'Interior Grouping',
              id: '',
              data: {}
            },
            tableId: 'groupingBankDetails',
            field: {
              area: 'SFG',
              perimeter: 'PERG'
            }
          },"bankArea":_vm.area,"bankPerimeter":_vm.perimeter,"conditionFactorList":_vm.conditionFactorList},on:{"updateTakeOff":_vm.updateTakeOff}})],1)]):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }